import { render, staticRenderFns } from "./DiscardAddAIBroadcast.vue?vue&type=template&id=44ce6a52&scoped=true&"
import script from "./DiscardAddAIBroadcast.vue?vue&type=script&lang=js&"
export * from "./DiscardAddAIBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./DiscardAddAIBroadcast.vue?vue&type=style&index=0&id=44ce6a52&lang=scss&scoped=true&"
import style1 from "./DiscardAddAIBroadcast.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ce6a52",
  null
  
)

export default component.exports